module.exports = __webpack_public_path__ + "img/edge_step_4.a9fd1963.png";